<template>
  <div>
    <!-- <Breadcrumb :options="breadcrumb" /> -->

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #start>
        <el-form-item v-if="user && ![2, 3, 4, 5].includes(user.user_group_id) && $route.params.status == 1" class="startBtn">
          <el-button type="primary" @click="addItem" icon="el-icon-plus">添加</el-button>
        </el-form-item>
      </template>
      <!-- 导出按钮 -->
      <template #end>
        <el-form-item class="endBtn">
          <el-button type="primary" icon="el-icon-download" @click="Export(`维修商列表_第${page}页`)">导出</el-button>
        </el-form-item>
      </template>
      <!-- 表头设置控件 -->
      <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
          @onChange="onTableSelect" />
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange"></Table>

    <FormDialog ref="dialog" :title="title" :labelWidth="'110px'" :width="'548px'" :form="mform" :rules="mrules"
      :formCtrl="mformCtrl" :viewMode="viewMode" @onModalSubmit="onModalSubmit"></FormDialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'reunit',
      breadcrumb: [
        { name: "维保管理", path: `/fix/repairer` },
        { name: "维修商管理", path: `/fix/repairer` },
      ],
      formCtrl: [
        {
          label: "维修商名称",
          keyName: "maunit",
          placeholder: "请填写维修商名称",
          type: "text",
        },
      ],
      cols: [
        { keyName: "maunit", label: "维修商名称" },
        { keyName: "address", label: "地址" },
        { keyName: "contact", label: "联系人" },
        { keyName: "phone", label: "联系电话" },
      ],
      btns: [
        {
          ...this.viewBtn,
          cb: (data) => {
            this.title = '查看'
            this.viewMode = true
            this.getItem(data);
            this.showDialog();
          },
        },
        {
          ...this.editBtn,
          cb: (data) => {
            this.title = '编辑'
            this.viewMode = false
            this.getItem(data);
            this.mformCtrl.map(c => {
              if (c.keyName == 'username') {
                c.disabled = true
              }
            })
            this.$forceUpdate()
            this.showDialog();
          },
        },
        // {
        //   ...this.delBtn,
        //   cb: ({ id }) => {
        //     this.delete(id)
        //   },
        // },
        {
          title: "订单列表",
          img: require('@/assets/img/icon_order.png'),
          unimg: require('@/assets/img/icon_order_hover.png'),
          cb: ({ id }) => {
            console.log(id)
            this.$router.push(
              `/fix/repairer/orderlist?r_id=${id}`
            );
          },
        },
        {
          title: '打款记录',
          img: require('@/assets/img/shipper_order_list.png'),
          unimg: require('@/assets/img/shipper_order_list_hover.png'),
          cb: ({ id, user_id, maunit }) => {
            this.$router.push(
              `/fix/repairer/payment?id=${id}&add_id=${user_id}&name=${maunit}`
            );
          },
        },
      ],
      title: '添加',
      viewMode: false,
      mform: {},
      mrules: {
        maunit: [
          {
            required: true,
            message: '请填写维修商名称',
            trigger: 'blur',
          }
        ],
        address: [
          {
            required: true,
            message: '请填写地址',
            trigger: 'blur',
          }
        ],
        contact: [
          {
            required: true,
            message: '请填写联系人',
            trigger: 'blur',
          }
        ],
        phone: [
          {
            required: true,
            validator: this.checkPhone,
            trigger: "blur"
          },
        ],
        username: [
          {
            required: true,
            message: '请填写账号',
            trigger: 'blur',
          }
        ],
        password: [
          { required: true, message: "请填写密码", trigger: "blur" },
          { min: 6, message: "长度不小于 6 位", trigger: "blur" },
        ],
      },
      mformCtrl: [
        {
          label: "维修商名称",
          keyName: "maunit",
          err: "请填写维修商名称",
          type: "text",
        },
        {
          label: "地址",
          keyName: "address",
          err: "请填写地址",
          type: "text",
        },
        {
          label: "联系人",
          keyName: "contact",
          err: "请填写联系人",
          type: "text",
        },
        {
          label: "联系电话",
          keyName: "phone",
          err: "请填写联系电话",
          type: "text",
        },
        {
          label: "状态",
          keyName: "status",
          err: "请选择状态",
          type: "select",
          options: [
            { label: '在用', value: 'active' },
            { label: '停用', value: 'disabled' },
          ],
        },
        {
          label: "账号",
          keyName: "username",
          err: "请填写账号",
          type: "text",
        },
        {
          label: "密码",
          keyName: "password",
          err: "请填写密码",
          type: "password",
        },
      ],
      baseParams: ['status'],
    };
  },
  methods: {
    addItem() {
      this.title = '添加'
      this.viewMode = false
      this.mform = {
        maunit: null,
        address: null,
        contact: null,
        phone: null,
        status: 'active',
        username: null,
        password: null,
      }
      this.mformCtrl.map(c => {
        if (c.keyName == 'username') {
          c.disabled = false
        }
      })
      this.$forceUpdate()
      console.log('表单', { ...this.mform })
      this.showDialog();
    },
    getItem({ id }) {
      this.loading = true;
      let url = `${this.baseUrl}/item`;
      const params = {
        // userid: this.user.id,
        id,
      };
      this.post(
        url,
        params,
        (res) => {
          const { msg, data } = res;
          if (msg === "success" && data) {
            // console.log(data);
            this.mformCtrl.map((v) => {
              const key = v.keyName;
              this.$set(this.mform, key, data[key])
            });
            this.mform['id'] = id
            this.$forceUpdate()
          } else {
            this.$message({
              type: "error",
              message: "加载失败，请稍后再试！",
            });
          }
          this.loading = false;
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "获取数据失败，请稍后重试！",
          });
        }
      );
    },
    // onChange({ key, value }) {
    //   console.log(key, value)
    //   // this.$set(this.mform, key, value)
    //   // this.$forceUpdate()
    //   console.log({ ...this.mform });
    // },
    setParams() {
      const { status } = this.$route.params
      // console.log(status)
      this.formInline.status = status == 1 ? 'active' : 'disabled'
      // console.log('formInline', { ...this.formInline })
      this.getList()
    },
  },
  watch: {
    $route() {
      // console.log(from.path, to.path)
      // console.log(this.$route.params)
      this.setParams()
    },
  },
  mounted() {
    this.setParams()
  },
};
</script>

<style lang="less" scoped></style>
